import React from 'react';

interface ModernCardProps {
  children: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
  icon?: React.ReactNode;
  gradient?: boolean;
}

const ModernCard: React.FC<ModernCardProps> = ({ 
  children, 
  className = '', 
  title, 
  icon, 
  gradient = false 
}) => {
  return (
    <div className={`
      ${gradient ? 'bg-gray-50 dark:bg-slate-800/50 border-gray-300 dark:border-slate-600' : 'bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700'} 
      border
      rounded-lg
      shadow-sm dark:shadow-lg
      p-6
      flex flex-col
      ${className}
    `}>
      {(title || icon) && (
        <div className="mb-4">
          {title && typeof title === 'string' ? (
            <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100">{title}</h3>
          ) : (
            title
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default ModernCard;
